import { render } from "./BillingDoughnutChart.vue?vue&type=template&id=521dd0a6&scoped=true"
import script from "./BillingDoughnutChart.vue?vue&type=script&lang=js"
export * from "./BillingDoughnutChart.vue?vue&type=script&lang=js"

import "./BillingDoughnutChart.vue?vue&type=style&index=0&id=521dd0a6&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521dd0a6"]])

export default __exports__